<template>
    <b-modal
        v-model="isOpened"
        :title="modalTitle"
        modal-class="add-user-modal"
        size="md"
        @show="setModalData"
        @hide="clearModalData"
    >
        <div class="d-flex">
            <!-- <div class="d-none">
                <input type="file" name="avatar" ref="avatarInput" @change="uploadImage">
            </div> -->
            <!-- <div class="avatar-col d-flex flex-column p-2 mr-3 border">
                <cropper
                    :src="image"
                    :stencil-component="$options.components.CircleStencil"
                    class="avatar-cropper"
                    ref="cropper"
                />
                <b-button-group class="mt-auto">
                    <b-button size="sm" @click="reset">Remover</b-button>
                    <b-button size="sm" @click="addOrCrop">{{ !this.image ? 'Adicionar' : 'Cortar' }}</b-button>
                </b-button-group>
            </div> -->
            <div class="flex-grow-1">
                <b-form-group
                    id="input-group-name"
                    label="Nome:"
                    label-for="input-name"
                >
                    <b-form-input
                        v-model="form.displayName"
                        id="input-name"
                        required
                        placeholder="Digite seu nome"
                    />
                </b-form-group>
                <b-form-group
                    id="input-group-name"
                    label="Email:"
                    label-for="input-email"
                >
                    <b-form-input
                        v-model="form.email"
                        id="input-email"
                        required
                        placeholder="email@exemplo.com"
                    />
                </b-form-group>
                <!-- <label class="switch switch-primary mt-3 mr-3">
                    <span>Gestor</span>
                    <input v-model="form.manager" type="checkbox" checked />
                    <span class="slider"></span>
                </label> -->

                <!-- <div class="mt-2 semi" v-if="uploadProgress" style="white-space: pre;">
                    Progresso do Upload: {{ uploadProgress }}%
                </div> -->
            </div>
        </div>
        <div slot="modal-footer">
            <b-btn
                @click="clearModalData"
                variant="secondary"
            >
                Cancelar
            </b-btn>
            <b-btn
                @click="!modalData ? createUser() : editUser()"
                variant="primary"
                class="ml-2"
            >
                Salvar
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
// import { Cropper, CircleStencil } from 'vue-advanced-cropper'
export default {
    name: 'AddEditUser',
    data () {
        return {
            uid: null,
            form: {
                displayName: '',
                email: '',
                gender: '',
                birthDate: '',
                companySector: '',
                occupation: '',
                manager: false,
                photoURL: '',
            },
            // image: null,
        }
    },
    // components: {
    //     Cropper,
    //     // eslint-disable-next-line vue/no-unused-components
    //     CircleStencil,
    // },
    methods: {
        // reset () {
        //     this.image = null
        // },
        // uploadImage (event) {
        //     var input = event.target
        //     if (input.files && input.files[0]) {
        //         var reader = new FileReader()
        //         reader.onload = (evt) => (this.image = evt.target.result)
        //         reader.readAsDataURL(input.files[0])
        //     }
        // },
        // addOrCrop () {
        //     if (!this.image) return this.$refs.avatarInput.click()

        //     this.crop()
        // },
        // crop () {
        //     const { canvas } = this.$refs.cropper.getResult()
        //     this.image = canvas.toDataURL()
        // },
        _createUser (data) {
            this.$store
                .dispatch('auth/createUser', data)
                .then(() => {
                    this.isOpened = !this.isOpened
                })
                .catch(response => {
                    if (response.response.data.code !== undefined && response.response.data.code === 'auth/email-already-exists') {
                        this.$bvToast.toast('Já existe um usuário cadastrado com esse e-mail.', {
                            title: 'E-mail duplicado!',
                            variant: 'warning',
                            solid: true,
                        })
                    }
                })
        },
        createUser () {
            const data = { form: this.form }
            if (this.image) {
                const { canvas } = this.$refs.cropper.getResult()
                canvas.toBlob(blob => {
                    blob.name = this.form.email || 'user-' + +new Date()
                    data.image = blob
                    this._createUser(data)
                })
                return
            }

            this._createUser(data)
        },
        _editUser (data) {
            this.$store
                .dispatch('auth/editUser', data)
                .then(() => {
                    this.isOpened = !this.isOpened
                })
        },
        editUser () {
            const data = { form: this.form, uid: this.uid }
            // if (this.image && this.image !== this.modalData.photoURL) {
            //     const { canvas } = this.$refs.cropper.getResult()
            //     canvas.toBlob(blob => {
            //         blob.name = this.form.email || 'user-' + +new Date()
            //         data.image = blob
            //         this._editUser(data)
            //     })
            //     return
            // }

            this._editUser(data)
        },
        setModalData () {
            if (!this.modalData) return

            const { uid, displayName, email, manager, photoURL } = this.modalData

            this.uid = uid
            this.form.displayName = displayName
            this.form.email = email
            this.form.manager = manager
            this.image = photoURL
        },
        clearModalData () {
            this.isOpened = false
            this.$store.dispatch('modals/setData', { key: 'addEditUserData', data: null })
        },
    },
    computed: {
        modalData () {
            return this.$store.getters['modals/getProperty']('addEditUserData')
        },
        modalTitle () {
            return !this.modalData ? 'Adicionar Usuário' : 'Editar Usuário'
        },
        isOpened: {
            get () {
                return this.$store.getters['modals/isOpened']('addEditUser')
            },
            set () {
                return this.$store.dispatch('modals/close', 'addEditUser')
            },
        },
        uploadProgress () {
            const progress = this.$store.getters['files/progress']
            return progress ? String(progress).padStart(3, ' ') : 0
        },
    },
}
</script>

<style lang="scss">
.add-user-modal {
    .avatar-col {
        width: 200px;
        .btn {
            border-color: #ccc !important;
        }
        .btn-group > .btn:not(:last-child):not(.dropdown-toggle), .btn-group > .btn-group:not(:last-child) > .btn {
            border-top-left-radius: 0 !important;
        }
        .btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) > .btn {
            border-top-right-radius: 0 !important;
        }
        .avatar-cropper {
            width: 182px;
            height: 182px;
            border-top: 1px solid #ccc;
            border-right: 1px solid #ccc;
            border-left: 1px solid #ccc;
        }
    }
}
</style>
